import ky, { TimeoutError, HTTPError } from 'ky';
import chunk from 'lodash/chunk';
import { ENV } from 'src/utils/env';
import { deleteAllActiveUploadItems } from 'src/components/EposUpload/epos-upload-store';
import { SalesData } from './sales-data-schema';

/**
 * smartUploadRequestFn
 * Attempt the upload with the full data set (previously chunked)
 * If timeout error occurs, means request was too large, so retry with "chunked chunked" data
 * otherwise return the error
 */

export const smartUploadRequestFn = async (salesData: SalesData, apiKey: string) => {
  const endpointWithApiKey = `${ENV.EPOS_UPLOAD_API_URL}/upload/?api_key=${apiKey}&resource_type=epos`;

  try {
    const res = await ky.post(endpointWithApiKey, {
      body: JSON.stringify(salesData),
    });

    if (res.status === 200) {
      return {
        success: true,
      };
    }

    const parsedResponse: {
      data: {
        msg: string;
      };
    } = await res.json();

    return {
      success: false,
      reason: parsedResponse?.data?.msg || 'unknown error',
    };
  } catch (e) {
    const errorMessage = (e as Error)?.message;

    if (e instanceof HTTPError) {
      if (e.response.status === 401) {
        deleteAllActiveUploadItems();
      }
    }

    /**
     * Retry Error with more Chunked Data
     */
    if (e instanceof TimeoutError) {
      const chunkedData = chunk(salesData, Math.ceil(salesData.length / 2));

      const res = await Promise.all(
        chunkedData.map((_chunk) =>
          ky.post(endpointWithApiKey, {
            body: JSON.stringify(_chunk),
          })
        )
      );

      if (res.every((item) => item.status === 200)) {
        return {
          success: true,
        };
      }
    }

    return {
      success: false,
      reason: errorMessage,
    };
  }
};
